export var FlowStepToolboxItemType;
(function (FlowStepToolboxItemType) {
    FlowStepToolboxItemType[FlowStepToolboxItemType["Step"] = 0] = "Step";
    FlowStepToolboxItemType[FlowStepToolboxItemType["Form"] = 1] = "Form";
    FlowStepToolboxItemType[FlowStepToolboxItemType["Flow"] = 2] = "Flow";
    FlowStepToolboxItemType[FlowStepToolboxItemType["Rule"] = 3] = "Rule";
    FlowStepToolboxItemType[FlowStepToolboxItemType["Report"] = 4] = "Report";
})(FlowStepToolboxItemType || (FlowStepToolboxItemType = {}));
;
